var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import Fuse from 'fuse.js';
import { groupBy } from 'underscore';
import { isEnumListInput } from '../parsing/UiTypesSpec';
var MIN_SEARCH_LENGTH = 3;
// fuzzy score threshold - 0 means perfect match, 1 means not at all
// this number is selected through trial and error
var FUZZY_THRESHOLD = 0.3;
export var searchModule = function (input, search) {
    var result = init(input);
    if (search.length < MIN_SEARCH_LENGTH) {
        return result;
    }
    result.state = 'hide';
    if (isStringMatch([input.name], search)) {
        result.state = 'expand';
        return result;
    }
    for (var _i = 0, _a = Object.entries(result.groups); _i < _a.length; _i++) {
        var _b = _a[_i], groupName = _b[0], group = _b[1];
        group.state = 'hide';
        if (isStringMatch([groupName], search)) {
            result.state = 'expand';
            group.state = 'expand';
            continue;
        }
        for (var _c = 0, _d = Object.entries(group.inputs); _c < _d.length; _c++) {
            var _e = _d[_c], inputName = _e[0], input_1 = _e[1];
            // for now we don't hide unmatched inputs within a module
            // input.state = 'hide'
            if (isStringMatch(__spreadArray([inputName], input_1.contents, true), search)) {
                result.state = 'expand';
                group.state = 'expand';
                input_1.state = 'expand';
            }
        }
    }
    return result;
};
var init = function (input) {
    var result = {
        state: 'none',
        groups: {},
    };
    var groupedInputs = groupBy(input.inputs.map(function (input) {
        var _a;
        return (__assign(__assign({}, input), { group: (_a = input.group) !== null && _a !== void 0 ? _a : '_' }));
    }), 'group');
    for (var _i = 0, _a = Object.entries(groupedInputs); _i < _a.length; _i++) {
        var _b = _a[_i], name_1 = _b[0], inputs = _b[1];
        result.groups[name_1] = {
            state: 'none',
            inputs: inputs.reduce(function (acc, v) {
                var _a;
                return (__assign(__assign({}, acc), (_a = {}, _a[v.label] = {
                    state: 'none',
                    contents: getInputContents(v),
                }, _a)));
            }, {}),
        };
    }
    return result;
};
var getInputContents = function (input) {
    var inputContents = [];
    if (isEnumListInput(input)) {
        for (var _i = 0, _a = input.enum; _i < _a.length; _i++) {
            var v = _a[_i];
            if (typeof v === 'string') {
                inputContents.push(v);
            }
            else {
                inputContents.push(v.label, v.value);
            }
        }
    }
    if (input.type === 'text' && input.default) {
        inputContents.push(input.default);
    }
    if (input.type === 'stringlist' && input.default) {
        inputContents.push.apply(inputContents, input.default);
    }
    if (input.type === 'style' && input.exampleItem) {
        inputContents.push(input.exampleItem);
    }
    inputContents.push(input.label);
    return inputContents;
};
var isStringMatch = function (inputs, search) {
    var fuse = new Fuse(inputs, {
        includeScore: true,
    });
    var result = fuse.search(search);
    return result.some(function (r) { var _a; return ((_a = r.score) !== null && _a !== void 0 ? _a : 1) < FUZZY_THRESHOLD; });
};
